const TYPE_LABELS = {
  patient: "Client",
  practitioner: "Caregiver",
  appointment: "Shift",
  encounter: "Encounter",
};

export function SyncedRecordsTable({ records = [], loading, total = 0, page = 1, limit = 50 }) {
  if (loading) {
    return (
      <div className="rounded-lg border bg-white p-6 text-sm text-slate-500">
        Loading synced records…
      </div>
    );
  }

  if (!records.length) {
    return (
      <div className="rounded-lg border bg-white p-6 text-sm text-slate-500">
        No records match this filter.
      </div>
    );
  }

  const totalPages = Math.max(1, Math.ceil(total / limit));

  return (
    <div className="space-y-3">
      <p className="text-xs text-slate-500">
        Showing {records.length} of {total} (page {page} of {totalPages})
      </p>
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-3">Type</th>
              <th className="px-4 py-3">Name / ID</th>
              <th className="px-4 py-3">Details</th>
              <th className="px-4 py-3">WellSky ID</th>
              <th className="px-4 py-3">In Albert</th>
              <th className="px-4 py-3">Bridge</th>
            </tr>
          </thead>
          <tbody>
            {records.map((row) => (
              <tr key={row.id} className="border-t">
                <td className="px-4 py-3">
                  {TYPE_LABELS[row.resourceType] || row.resourceType}
                </td>
                <td className="px-4 py-3 font-medium">{row.name}</td>
                <td className="max-w-xs px-4 py-3 text-slate-600">{row.detail || "—"}</td>
                <td className="px-4 py-3 font-mono text-xs">{row.externalId}</td>
                <td className="px-4 py-3 font-mono text-xs">
                  {row.myAlbertId ? row.myAlbertId : "—"}
                </td>
                <td className="max-w-xs px-4 py-3 text-xs">
                  {row.bridgedAt ? (
                    <span className="text-emerald-700">Linked</span>
                  ) : row.bridgeError ? (
                    <span className="text-amber-800" title={row.bridgeError}>
                      {row.bridgeError}
                    </span>
                  ) : (
                    <span className="text-slate-400">Staging only</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
